var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"header"},[_c('div',{staticClass:"inner"},[_c('img',{staticClass:"logo cursor",attrs:{"src":require("@/assets/images/logo.png"),"alt":""},on:{"click":_vm.toHome}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }